import { passwordRegex } from "./regexUtils";

export const validateAuthentification = (formFields) => {
  let errors = {};
  let isValid = true;

  if (!formFields.username) {
    errors.username = "Nom d'utilisateur est nécessaire";
    isValid = false;
  }

  if (!formFields.password) {
    errors.password = "Mot de passe requis";
    isValid = false;
  }

  return { isValid, errors };
};

export const validateMceDecision = (formFields) => {
  let errors = {};
  let isValid = true;

  if (!formFields.decision) {
    errors.decision = "Décision est nécessaire";
    isValid = false;
  }

  if (formFields.decision === 1) {
    let formDebut = Math.floor(new Date(formFields.dateDebut).getTime() / 1000);
    let formFin = Math.floor(new Date(formFields.dateFin).getTime() / 1000);
    let isDebutBigger = formDebut > formFin;

    let isCorrectVisa = /^[a-zA-Z0-9]+$/.test(formFields.numVisa);
    if (!formFields.numVisa) {
      errors.numVisa = "Nº du visa est nécessaire";
      isValid = false;
    } else if (!isCorrectVisa) {
      errors.numVisa = "Nº du visa doit être d'un format valide";
      isValid = false;
    }

    if (!formFields.montantAccorde) {
      errors.montantAccorde = "Montant accorde est nécessaire";
      isValid = false;
    }
    if (!formFields.poidsNet) {
      errors.poidsNet = "Poids net est nécessaire";
      isValid = false;
    }

    if (!formFields.quantite) {
      errors.quantite = "Quantite est nécessaire";
      isValid = false;
    }

    if (!formFields.unites) {
      errors.unites = "Unités est nécessaire";
      isValid = false;
    }

    if (!formFields.unitesComp) {
      errors.unitesComp = "Unités complémentaires est nécessaire";
      isValid = false;
    }

    if (!formFields.dateDebut) {
      errors.dateDebut = "Date debut est nécessaire";
      isValid = false;
    }

    if (!formFields.dateFin) {
      errors.dateFin = "Date fin est nécessaire";
      isValid = false;
    }

    if (isDebutBigger) {
      errors.dateFin =
        "La date de fin ne peut pas être antérieure à la date de début.";
      isValid = false;
    }
  } else if (formFields.decision !== 1 && formFields.decision !== "") {
    let isCorrectComment = /[a-zA-Z0-9]/.test(formFields.commentaire);

    if (!isCorrectComment) {
      errors.commentaire = "Commentaire est nécessaire";
      isValid = false;
    }
  }

  return { isValid, errors };
};

export const validateMceLeDecision = (formFields) => {
  let errors = {};
  let isValid = true;

  if (!formFields.decision) {
    errors.decision = "Décision est nécessaire";
    isValid = false;
  }

  if (formFields.decision === 1) {
    let isCorrectVisa = /^[a-zA-Z0-9]+$/.test(formFields.numVisa);
    if (!formFields.numVisa) {
      errors.numVisa = "Nº du visa est nécessaire";
      isValid = false;
    } else if (!isCorrectVisa) {
      errors.numVisa = "Nº du visa doit être d'un format valide";
      isValid = false;
    }

    if (!formFields.dateFin) {
      errors.dateFin = "Date fin est nécessaire";
      isValid = false;
    }
  } else if (formFields.decision !== 1 && formFields.decision !== "") {
    let isCorrectComment = /[a-zA-Z0-9]/.test(formFields.commentaire);

    if (!isCorrectComment) {
      errors.commentaire = "Commentaire est nécessaire";
      isValid = false;
    }
  }

  return { isValid, errors };
};

export const validateMceTiProlongation = (formFields) => {
  let errors = {};
  let isValid = true;

  if (!formFields.decision) {
    errors.decision = "Décision est nécessaire";
    isValid = false;
  }

  if (formFields.decision === 1) {
    if (!formFields.dateFin) {
      errors.dateFin = "Date fin est nécessaire";
      isValid = false;
    }
  } else if (formFields.decision !== 1 && formFields.decision !== "") {
    let isCorrectComment = /[a-zA-Z0-9]/.test(formFields.commentaire);

    if (!isCorrectComment) {
      errors.commentaire = "Commentaire est nécessaire";
      isValid = false;
    }
  }

  return { isValid, errors };
};

export const validateMceTiDecision = (formFields) => {
  let errors = {};
  let isValid = true;

  if (!formFields.decision) {
    errors.decision = "Décision est nécessaire";
    isValid = false;
  }

  if (formFields.decision === 1) {
    let isCorrectVisa = /^[a-zA-Z0-9]+$/.test(formFields.numVisa);
    if (!formFields.numVisa) {
      errors.numVisa = "Nº du visa est nécessaire";
      isValid = false;
    } else if (!isCorrectVisa) {
      errors.numVisa = "Nº du visa doit être d'un format valide";
      isValid = false;
    }

    if (!formFields.dateFin) {
      errors.dateFin = "Date fin est nécessaire";
      isValid = false;
    }
  } else if (formFields.decision !== 1 && formFields.decision !== "") {
    let isCorrectComment = /[a-zA-Z0-9]/.test(formFields.commentaire);

    if (!isCorrectComment) {
      errors.commentaire = "Commentaire est nécessaire";
      isValid = false;
    }
  }

  return { isValid, errors };
};

export const validateDepDecision = (formFields) => {
  let errors = {};
  let isValid = true;

  if (!formFields.decision) {
    errors.decision = "Décision est nécessaire";
    isValid = false;
  }
  if (formFields.decision !== 1 && formFields.decision !== "") {
    let isCorrectComment = /[a-zA-Z0-9]/.test(formFields.commentaire);

    if (!isCorrectComment) {
      errors.commentaire = "Commentaire est nécessaire";
      isValid = false;
    }
  }

  return { isValid, errors };
};
export const validateMotDePasse = (formFields) => {
  let errors = {};
  let isValid = true;

  if (!formFields.currentPassword) {
    errors.currentPassword = "Mot de passe actuel requis";
    isValid = false;
  }

  if (formFields.newPassword === formFields.currentPassword) {
    errors.newPassword =
      "Le nouveau mot de passe ne peut pas être identique à l'ancien";
    isValid = false;
  }
  if (!formFields.newPassword) {
    errors.newPassword = "Nouveau mot de passe requis";
    isValid = false;
  }

  if (!formFields.confirmNewPassword) {
    errors.confirmNewPassword = "Confirmation du nouveau mot de passe requis";
    isValid = false;
  }

  if (formFields.newPassword !== formFields.confirmNewPassword) {
    errors.confirmNewPassword =
      "La confirmation du nouveau mot de passe ne correspond pas";
    isValid = false;
  }

  if (formFields.newPassword === formFields.currentPassword) {
    errors.newPassword =
      "Le nouveau mot de passe ne peut pas être identique à l'ancien";
    isValid = false;
  }

  if (!passwordRegex.test(formFields.newPassword)) {
    errors.newPassword =
      "Le mot de passe doit comporter au moins 8 caractère, au moins 1 chiffre, au moins 1 lettre minuscule, au moins 1 lettre majuscule,au moins 1 caractère spécial";
    isValid = false;
  }

  return { isValid, errors };
};
